import React from "react";
import { Link } from "react-router-dom";

export default function Disclaimer() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-20" data-testid="disclaimer-page">
      <div className="overline">LEGAL · RESEARCH USE DISCLAIMER</div>
      <h1 className="font-heading text-4xl sm:text-5xl font-light leading-tight mt-3">
        Disclaimer
      </h1>
      <p className="text-xs font-mono-tech text-[#5C657A] mt-3 uppercase tracking-[0.2em]">
        Effective: May 2026 · ProSource Labs LLC
      </p>

      <div className="mt-12 space-y-10 text-[#8A94A6] leading-relaxed">
        <section>
          <h2 className="font-heading text-xl text-white mb-3">For Research Use Only</h2>
          <p>
            Every compound supplied by <span className="text-white">ProSource Labs LLC</span> is
            manufactured, labeled, and sold strictly for <span className="text-white">in‑vitro
            laboratory research and analytical applications</span>. Our peptides and chemical
            reference materials are not designed for, and may not be used in, the diagnosis,
            treatment, cure, mitigation, or prevention of any disease or condition in humans or
            animals.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-xl text-white mb-3">Not for Human or Animal Use</h2>
          <p>
            Products purchased from ProSource Labs are <span className="text-white">not
            food, cosmetics, dietary supplements, or pharmaceutical drugs</span>. They are not
            intended for ingestion, injection, inhalation, topical application, mucosal exposure,
            implantation, or any other form of bodily introduction in humans or animals. By
            purchasing from this website, you affirm that the materials will be used solely
            within a controlled laboratory environment by a qualified researcher and will not be
            redirected to any human or veterinary use.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-xl text-white mb-3">FDA Statement</h2>
          <p>
            Statements presented on this website, in our marketing communications, or on product
            packaging <span className="text-white">have not been evaluated by the U.S. Food and
            Drug Administration</span> or any other regulatory body. None of the products listed
            herein are FDA‑approved for human or veterinary use. Any reference to historical
            studies, mechanisms of action, or scientific literature is for informational and
            educational purposes only and does not constitute medical advice or a claim of
            efficacy.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-xl text-white mb-3">No Medical Advice</h2>
          <p>
            Nothing published on prosourcelabs.org should be interpreted as professional medical,
            pharmaceutical, veterinary, nutritional, or scientific advice. The information
            provided is general in nature and is intended to support qualified researchers in
            their independent work. ProSource Labs does not establish a doctor–patient or
            similar advisory relationship with any visitor or customer.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-xl text-white mb-3">Researcher Responsibility</h2>
          <p>
            The buyer is solely responsible for: (i) verifying the legality of possessing,
            handling, and using each compound in their jurisdiction; (ii) ensuring proper
            laboratory practices, including sterile technique, dosage calculation, storage, and
            disposal; and (iii) preventing access to or use of the materials by any individual
            not authorized to handle research chemicals. ProSource Labs assumes no
            responsibility for misuse, off‑label use, or any harm — direct or indirect — that may
            result from the buyer's failure to observe these obligations.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-xl text-white mb-3">Accuracy of Information</h2>
          <p>
            While we make every reasonable effort to ensure that product descriptions,
            specifications, certificates of analysis, and other published information are
            accurate, ProSource Labs makes no representation or warranty regarding the
            completeness, currency, or reliability of any content on this website. Information
            may be updated or corrected without notice. If precise data is required for your
            research, please contact us in writing to request the most recent certificate of
            analysis for a specific lot.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-xl text-white mb-3">Acknowledgment</h2>
          <p>
            By browsing prosourcelabs.org and/or placing an order, you confirm that you have
            read, understood, and accepted this Disclaimer in its entirety, together with our
            <Link to="/terms" className="text-[#00C3FF] hover:underline mx-1">Terms &amp; Conditions</Link>
            and
            <Link to="/refund-policy" className="text-[#00C3FF] hover:underline mx-1">Refund Policy</Link>.
            If you do not agree, please discontinue use of this website immediately.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-xl text-white mb-3">Contact</h2>
          <p>
            Questions about this Disclaimer? Reach us at
            <a className="text-[#00C3FF] hover:underline ml-1" href="mailto:support@prosourcelabs.org">
              support@prosourcelabs.org
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}
